$('#nav_menu .nav-link').on('click', function () {
    setTimeout(function () {
        $('#nav_menu .nav-link').each(function () {
            if (!$(this).siblings('.submenu').hasClass('show')) {
                $(this).addClass('collapsed');
            }
        });
    }, 500);
});

document.addEventListener('wishlist-content-loaded', function (e) {
    $('.add-wishlist-button').click(function (e) {
        var that = $(this);
        var inputForm = '';
        $.ajax({
            type: 'POST',
            url: '/add_to_wishlist/' + that.data('id'),
            success: function (data) {
                that.hide();
                that.siblings('.remove-wishlist-button').show();
                that.siblings('.added-wishlist-alert').show();

                var savedAlert = $('.saved-alert');
                savedAlert.show();
            }
        });
    });

    $('.remove-wishlist-button').click(function (e) {
        var that = $(this);
        $.ajax({
            type: 'POST',
            url: '/remove_from_wishlist/' + that.data('id'),
            success: function (data) {
                that.hide();
                that.siblings('.add-wishlist-button').show();

                var removedAlert = $('.removed-wishlist-alert');
                removedAlert.show();
            }
        });
    });
});

$('.add-saved-configuration-button').click(function (e) {
    var that = $(this);
    that.prop('disabled', true);
    var inputForm = '';
    var description = '';
    var jobName = '';
    if ($('#PrintData').length) {
        var printData = JSON.parse($('#PrintData').val());
        inputForm = printData.inputForm;
        description = printData.descrizione;
    }

    if ($('#job_name').length) {
        jobName = $('#job_name').val();
    }
    $.ajax({
        type: 'POST',
        url: '/add_to_saved_configuration/' + that.data('id'),
        data: {
            inputForm: inputForm,
            description: description,
            jobName: jobName
        },
        success: function () {
            var savedAlert = $('.added-saved-configuration-alert');
            savedAlert.show();
            that.prop('disabled', false);
        }
    });
});
$('.added-saved-configuration-alert .btn-close').on('click', function (e) {
    $('.added-saved-configuration-alert').hide();
    e.preventDefault();
});

$('.print-product-quote-button').click(function (e) {
    var form = $('#form-product-quote-print');

    // Open a fresh named window on every click, synchronously inside the user gesture, so the
    // browser doesn't block or reuse the tab of a previous quote when the PDF is requested again.
    var target = 'product-quote-' + Date.now();
    // Deliberately no 'noopener': it makes window.open() return null and ignores the window name, so
    // the form could no longer be targeted at it. The window only shows our own same-origin PDF.
    var quoteWindow = window.open('', target);

    form.attr('target', quoteWindow ? target : '_blank');

    // With the full page cache on, the _token rendered in the form is the cached (stale) one, so
    // fetch a fresh token and sync it into the form before posting; otherwise the POST gets a 419.
    // The window is already open, so the async refresh doesn't trip the popup blocker.
    var submitForm = function () {
        form.get(0).submit();
    };

    if (typeof updateCsrfToken === 'function') {
        updateCsrfToken().always(submitForm);
    } else {
        submitForm();
    }
});

$('.download-pdf-button').click(function (e) {
    var that = $(this);
    var ttpdfParams = {};
    var slugTitle = '';

    if ($('#PrintData').length) {
        var printData = JSON.parse($('#PrintData').val() || '');
        ttpdfParams = printData.outputData.ttpdfParams;

        const productDescObj = printData.descrizione.find(
            (el) => el.nome == 'Prodotto'
        );
        const baseDescObj = printData.descrizione.find(
            (el) => el.nome == 'Scegli un Formato (Base)'
        );
        const altezzaDescObj = printData.descrizione.find(
            (el) => el.nome == 'Scegli un Formato (Altezza)'
        );
        const formatoDescObj = printData.descrizione.find(
            (el) => el.nome == 'Formato'
        );

        let title = `${productDescObj.valore}`;

        if (baseDescObj && altezzaDescObj) {
            title += ` ${baseDescObj.valore} x ${altezzaDescObj.valore}`;
        } else if (formatoDescObj) {
            title += ` ${formatoDescObj.valore}`;
        }

        slugTitle = title
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');
    }

    $.ajax({
        type: 'POST',
        url: '/products/download_pdf',
        data: {
            ttpdfParams: ttpdfParams
        },
        success: function (response) {
            var blob = new Blob([response], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            // Create a link element
            const link = document.createElement('a');

            // Set link's href to point to the Blob URL
            link.href = blobUrl;
            link.download = `${slugTitle}.pdf`;

            // Append link to the body
            document.body.appendChild(link);

            // This is necessary as link.click()
            link.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window
                })
            );

            // Remove link from body
            document.body.removeChild(link);
        }
    }).fail(function (response) {
        if (!response.success) {
            console.error('error', response.error);
            var errorAlert = $('.error-download-pdf-alert');
            errorAlert.show();
        }
    });
});

function checkModal(modalId) {
    if ($('#' + modalId).length) {
        return $('#' + modalId);
    } else {
        return $(document.body);
    }
}

$(document).ready(function () {
    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');
    if ($('#repository_code').length) {
        $('#repository_code').select2({
            theme: 'bootstrap4',
            minimumResultsForSearch: 1,
            dataAdapter: customAdapter,
            allowClear: true,
            dropdownParent: checkModal('repository-modal'),
            placeholder: function () {
                $(this).data('placeholder');
            }
        });
    }
});

$(window).on('formLoaded', (event) => {
    var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    const list = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="popover"]')
    );
    list.map((el) => {
        let opts = {
            animation: false
        };
        if (el.hasAttribute('data-bs-content-id')) {
            opts.content = document.getElementById(
                el.getAttribute('data-bs-content-id')
            ).innerHTML;
            opts.html = true;
        }
        new bootstrap.Popover(el, opts);
    });
});
$(window).on('refreshPopoverGrid', (event) => {
    var elements = document.querySelectorAll('[id^="popover-taglia"]');
    elements.forEach(function (element) {
        var dataBsContentId = element.getAttribute('data-bs-content-id');
        const popover = bootstrap.Popover.getOrCreateInstance('#' + element.id);
        popover.hide();
        setTimeout(() => {
            popover.setContent({
                '.popover-body':
                    document.getElementById(dataBsContentId).innerHTML
            });
        }, 100);
    });
});
$(window).on('destroyPopoverGrid', () => {
    const elements = document.querySelectorAll('[id^="popover-taglia"]');
    console.log('destroyPopoverGrid');
    elements.forEach(function (element) {
        const popover = bootstrap.Popover.getInstance(element);
        if (popover) {
            popover.dispose(); // Distrugge completamente l'istanza del popover
        }
    });
});

const LONG_DESCRIPTION_OVERFLOW_TOLERANCE = 1;
const LONG_DESCRIPTION_MEANINGFUL_CONTENT_SELECTOR =
    'img, picture, video, audio, iframe, svg, canvas, table, hr, input';
const LONG_DESCRIPTION_EMPTY_CHARACTERS = /[\s\u00a0\u200b-\u200d\ufeff]/g;

function isEmptyLongDescriptionParagraph(paragraph) {
    const text = paragraph.textContent.replace(
        LONG_DESCRIPTION_EMPTY_CHARACTERS,
        ''
    );

    return (
        text.length === 0 &&
        !paragraph.querySelector(LONG_DESCRIPTION_MEANINGFUL_CONTENT_SELECTOR)
    );
}

function longDescriptionOverflows(preview) {
    const emptyParagraphs = Array.from(preview.querySelectorAll('p')).filter(
        isEmptyLongDescriptionParagraph
    );
    const previousHiddenStates = emptyParagraphs.map(
        (paragraph) => paragraph.hidden
    );

    emptyParagraphs.forEach((paragraph) => {
        paragraph.hidden = true;
    });

    const isOverflowing =
        preview.scrollHeight >
        preview.clientHeight + LONG_DESCRIPTION_OVERFLOW_TOLERANCE;

    emptyParagraphs.forEach((paragraph, index) => {
        paragraph.hidden = previousHiddenStates[index];
    });

    return isOverflowing;
}

async function updateLongDescriptionTruncation() {
    const previews = document.querySelectorAll(
        '[data-long-description-preview="true"]'
    );

    if (previews.length === 0) {
        return;
    }

    if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
    }

    previews.forEach((preview) => {
        const catalogDetail = preview.closest('.catalog-detail');

        if (!catalogDetail) {
            return;
        }

        const isOverflowing = longDescriptionOverflows(preview);

        if (isOverflowing) {
            return;
        }

        preview.classList.remove('line-clamp');

        const readMoreButton = catalogDetail.querySelector(
            '[data-long-description-read-more]'
        );
        const fullDescription = catalogDetail.querySelector(
            '[data-long-description-full]'
        );

        if (readMoreButton) {
            readMoreButton.hidden = true;
        }

        if (fullDescription) {
            fullDescription.hidden = true;
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        updateLongDescriptionTruncation,
        { once: true }
    );
} else {
    updateLongDescriptionTruncation();
}
